export const getCroppedImg = (imageSrc, pixelCrop, fileName) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext("2d");
  
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );
  
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error("Canvas is empty"));
          blob.name = fileName;
          const croppedFile = new File([blob], fileName, { type: "image/png" });
          resolve(croppedFile);
        }, "image/png");
      };
      image.onerror = () => reject(new Error("Image load failed"));
    });
  };
  